














import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  private msg: string = "";
  protected created() {
    this.msg = this.$route.params.msg;
  }
}
